import type { TDeal } from "@/store";

/**
 * LaSalle deals have no segments, and the LaSalle API returns no segment
 * settings. The shared `TDeal` (Rev EU's shape) still requires them, so every
 * LaSalle deal fills them in switched off.
 */
export const NO_SEGMENTS: Pick<
    TDeal,
    | "requiresSegment2"
    | "requiresSegment3"
    | "requiresSegment4"
    | "requiresSegment5"
    | "requiresSegment6"
    | "requiresSegment7"
    | "segment2MappingType"
    | "segment4MappingType"
    | "segment5MappingType"
    | "segment6MappingType"
    | "segment7MappingType"
> = {
    requiresSegment2: false,
    requiresSegment3: false,
    requiresSegment4: false,
    requiresSegment5: false,
    requiresSegment6: false,
    requiresSegment7: false,
    segment2MappingType: "no_mapping",
    segment4MappingType: "no_mapping",
    segment5MappingType: "no_mapping",
    segment6MappingType: "no_mapping",
    segment7MappingType: "no_mapping",
};
